<template>
  <v-sheet class="text-center mx-auto" max-width="800">
    <h1
      :class="($vuetify.breakpoint.mdAndDown && 'display-1 font-weight-black') || 'main-title'"
      class="gadient-text mb-2"
    >
      Ready to use?
    </h1>
    <p class="grey--text display-1 mb-10">Get User Profile plugin and bring your creative 🚀 ideas to life.</p>
    <v-container>
      <v-row justify="center">
        <v-col cols="6" sm="5" v-for="(product, index) in productDetails" :key="index">
          <v-hover v-slot="{hover}">
            <v-card
              class="productCard rounded-lg py-10"
              :elevation="hover ? 16 : 2"
              :class="{'on-hover': hover}"
              @click="productLink(product)"
              color="grey darken-4"
            >
              <v-img
                style="margin: auto"
                width="90"
                height="90"
                class="mb-4"
                :src="require(`@/assets/icons/${product.icon}`)"
                :lazy-src="require(`@/assets/icons/${product.icon}`)"
              ></v-img>
              <v-card-actions class="justify-center py-4">
                <v-btn rounded outlined>Get For {{ product.title }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
  data: () => ({
    productDetails: [
      {
        title: 'Adobe XD',
        icon: 'adobexd.svg',
        url: 'https://xd.adobelanding.com/en/xd-plugin-download/?name=2418aad9',
      },
      {
        title: 'Figma',
        icon: 'figma.svg',
        url: 'https://www.figma.com/c/plugin/749945157855564842/User-Profile',
      },
    ],
  }),
  methods: {
    productLink(event) {
      this.$gtag.event(`${event.title.toLowerCase()} selected`, {
        event_category: 'product-selected-click',
        event_label: 'Selected product from section',
        value: 1,
      })
      window.open(event.url, '_blank')
    },
  },
}
</script>

<style scoped>
.productCard {
  transition: opacity 0.2s ease-in-out;
}
.productCard:not(.on-hover) {
  opacity: 0.6;
}
</style>
